/**
 * Drop-in <Card/> wrapper that auto-applies the `row-fresh` flash class
 * when the given (kind, id[, secondaryIds…]) combo is in the highlights
 * registry. Lets pages keep using `items.map(...)` without extracting a
 * row sub-component just to call the `useHighlight` hook (hooks can't
 * be called inside loops).
 *
 * Usage:
 *   <HighlightCard kind="payment" id={p.id} className="p-4 …">
 *     …row content…
 *   </HighlightCard>
 */
import { Card } from "./ui/card";
import { useHighlight } from "../lib/highlights";

export function HighlightCard({
  kind,
  id,
  secondaryIds = [],
  className = "",
  children,
  ...rest
}) {
  const fresh = useHighlight(kind, id, ...secondaryIds);
  return (
    <Card
      {...rest}
      className={`${className} ${fresh ? "row-fresh" : ""}`.trim()}
    >
      {children}
    </Card>
  );
}
